import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Slider from "@material-ui/core/Slider";
import Typography from '@material-ui/core/Typography';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
	{
		root: {
			width: '100%',
			height: '100%',
			border: '1px solid #979797',
			padding: '24px 20px 20px 20px'
		},
		content: {
			textAlign: 'left',
			padding: 0
		},
		cardTitleText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 600,
			letterSpacing: 0,
		},
		cardSubTitleText: {
			marginTop: 10,
			color: '#333333',
			fontFamily: 'Graphik',
			fontSize: 14,
			letterSpacing: 0,
		},
		barDiv: {
			marginTop: 35
		},
		minText: {
			color: '#333333',
  			fontFamily: 'Graphik',
  			fontSize: 12,
  			fontWeight: 600,
  			letterSpacing: 0,
			marginTop: 35,
		},
		maxText: {
			color: '#333333',
  			fontFamily: 'Graphik',
  			fontSize: 12,
  			fontWeight: 600,
  			letterSpacing: 0,
			float: 'right'
		}
	}
);

const CustomSlider = withStyles({
  rail: {
	height: 5,
    backgroundImage: "linear-gradient(.25turn, #00f, #f00)"
  },
  track: {
	height: 5,
	backgroundImage: "linear-gradient(.25turn, #00f, #f00)"
  },
  thumb: {
    "&:hover": {
        boxShadow: "none",
    }
  }
})(Slider);

const SliderBarCard = ( {title, subTitle, min, max, tooltipDisplay="off", bars=[]} ) => {
	const classes = useStyles();

	return (

		<Card className={classes.root}>
			<CardContent className={classes.content}>
				<Typography className={classes.cardTitleText}>
					{title}
				</Typography>
				<Typography className={classes.cardSubTitleText}>
					{subTitle}
				</Typography>
				{bars.map((bar, index) => (
						<React.Fragment key={"bar"+index}>
							<div className={classes.barDiv}>
								<span className={classes.minText}>{bar.minLabel}</span> <span className={classes.maxText}>{bar.maxLabel}</span>
							</div>
							<CustomSlider
								value={Number(bar.value)}
								min={min}
								max={max}
								valueLabelDisplay={tooltipDisplay}
        						aria-labelledby="continuous-slider"
      						/>
						</React.Fragment>
					))
				}	
        	</CardContent>
		</Card>
	)
}

export default SliderBarCard;
